import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppCurrency } from 'src/app/model/appCurrency';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppCurrencyService {
  private baseUrl = environment.apiUrl+'/api/admin/currencies';

  constructor(private http: HttpClient) {}

  getAll(): Observable<AppCurrency[]> {
    return this.http.get<AppCurrency[]>(this.baseUrl);
  }

  saveOrUpdate(currency: { code: string; rate: number }): Observable<AppCurrency> {
    return this.http.post<AppCurrency>(this.baseUrl, currency);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  convertFromEGP(to: string, amount: number): Observable<number> {
    return this.http.get<number>(`${this.baseUrl}/convert-from-egp`, {
      params: { to, amount: amount.toString() }
    });
  }

  convertToEGP(from: string, amount: number): Observable<number> {
    return this.http.get<number>(`${this.baseUrl}/convert-to-egp`, {
      params: { from, amount: amount.toString() }
    });
  }
}
